import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
        // background: {
        //     default: '#f6fcff',
        //     bw: '#ffffff',
        // },
        topCircle: {
            main: '#87B6CC'
        }
    },

    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
})
export default theme
